{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Chatwoot to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "E-mailová adresa",
      "PLACEHOLDER": "Prosím, zadejte svůj e-mail.",
      "ERROR": "Zadejte prosím platný e-mail."
    },
    "API": {
      "SUCCESS_MESSAGE": "Odkaz pro obnovení hesla byl odeslán na váš e-mail.",
      "ERROR_MESSAGE": "Nelze se připojit k Woot serveru, opakujte akci později"
    },
    "SUBMIT": "Odeslat"
  }
}
